import React from 'react'
import { Redirect } from 'react-router-dom'

export interface Props {
  /** Any React.ReactElement. */
  children: JSX.Element
  /** A boolean that decides when the children will render. */
  condition: boolean
}

export const If: React.FC<Props> = props => (props.condition ? props.children : null)

export const RedirectIf: React.FC<Props> = props => (props.condition ? props.children : <Redirect to='/401' />)

export default If
